export const ADS_BLOCK = '12345'
export const ADS_CLIENT = 'dostavka'
